import { makeStyles } from '@material-ui/core';
import { getConfig } from 'config/config';

const { theme } = getConfig();

export const useStyles = makeStyles({
  container: {
    position: 'relative',
    width: '100%',
    padding: '20px 0 40px',
    borderBottom: `2px solid ${theme.BACKGROUND_SECONDARY}`,
    borderLeft: `2px solid ${theme.BACKGROUND_SECONDARY}`,
    borderBottomLeftRadius: '10px',
    paddingLeft: '10px',
    paddingBottom: '10px',
  },
  senderWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    borderRadius: 30,
    border: '2px solid',
    overflow: 'hidden',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  image: {
    width: '100%',
  },
  heading: {
    marginLeft: 20,
    marginBottom: 5,
    cursor: 'pointer',
  },
  name: {
    display: 'flex',
    fontFamily: 'Poppins',
    fontWeight: 600,
    marginRight: 5,
  },
  prefix: {
    display: 'block',
    fontFamily: 'Poppins',
    fontWeight: 600,
  },
  commentWrapper: {
    width: '100%',
  },
  comment: {
    fontFamily: 'Roboto',
    fontSize: 15,
    margin: 0,
    padding: '30px 10px 20px',
    wordBreak: 'break-word',
    maxWidth: 500,
    whiteSpace: 'pre-wrap',
  },
  kreise: {
    fontFamily: 'Poppins',
    marginLeft: 5,
  },
  date: {
    display: 'block',
    fontFamily: 'Roboto',
    fontSize: 14,
  },

  likeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  leftButton: {
    boxSizing: 'border-box',
    width: 50,
    marginRight: 2,
    borderRadius: '50px 0 0 50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightButton: {
    padding: '12px 0',
    width: 50,
    borderRadius: '0 50px 50px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  commentsButton: {
    padding: '13px 30px',
    borderRadius: 50,
  },
  commentsLabel: {
    fontFamily: 'Roboto',
    fontSize: 15,
  },
  likeLabel: {
    fontFamily: 'Roboto',
    fontSize: 15,
    lineHeight: '21px',
    display: 'block',
  },
  deleteButton: {
    position: 'absolute',
    top: 25,
    right: 0,
    width: 25,
    height: 25,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '@media(max-width: 650px)': {
    name: {
      lineHeight: '16px',
    },
    comment: {
      maxWidth: 320,
    },
  },
});
